"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

var GroupedView = function GroupedView() {
  return _react2.default.createElement(
    "svg",
    { focusable: "false", "aria-hidden": true, className: "icon-svg-grouped-view", preserveAspectRatio: "xMinYMin meet", viewBox: "0 0 16 16" },
    _react2.default.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      _react2.default.createElement("path", { fill: "#000", d: "M1.75 16L0 16 0 1.75 0 0 5 0 5 1.75 1.75 1.75 1.75 14.25 5 14.25 5 16 1.75 16zM14.25 14.25L14.25 1.75 11 1.75 11 0 16 0 16 1.75 16 16 14.25 16 11 16 11 14.25 14.25 14.25z" }),
      _react2.default.createElement("rect", { width: "4.75", height: "2", x: "7.25", y: "5", fill: "#000" }),
      _react2.default.createElement("rect", { width: "2", height: "2", x: "4", y: "5", fill: "#000" }),
      _react2.default.createElement("rect", { width: "4.75", height: "2", x: "7.25", y: "9", fill: "#000" }),
      _react2.default.createElement("rect", { width: "2", height: "2", x: "4", y: "9", fill: "#000" })
    )
  );
};

exports.default = GroupedView;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/GroupedView/GroupedView.js
// module id = 229
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15